import { FileLogger } from "@logger";

export type TFields = {
	[internalName: string]: string;
}

export abstract class BaseResource {
	protected logger: FileLogger | Console;
	protected originalLogger: FileLogger | null;

	constructor({ logger = null }: { logger?: FileLogger | null } = {}) {
		this.originalLogger = logger;
		this.logger = logger ? logger.extend(this.getLoggerExtension()) : console;
	}

	abstract getLoggerExtension(): string;
}